/** Bubble Bomb mutation — effect is that next queued bubble becomes a bomb, board unchanged */

import type { PRNG } from '../../rng.js';
import type { BoardState, MutationCard } from '../../types.js';

export function applyBubbleBomb(
  board: BoardState,
  _card: MutationCard,
  _rng: PRNG,
): BoardState {
  // Board state is unchanged — the bomb effect is applied to the next
  // queued bubble at shot time via the engine.
  return board;
}
